// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action } from '../actions/listingCounts';

export type State = Record<string, number> | null | undefined;
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/default-param-last
export default function listingCounts(state: State = null, action: Action) {
  switch (action.type) {
    case 'LISTING_COUNTS_SET': {
      return action.counts;
    }

    default:
      // this causes a flow error if there are any unhandled actions
      action as never; // eslint-disable-line no-unused-expressions

      return state;
  }
}
